import React, { PureComponent } from 'react';
import { Form, InputNumber, message, Modal } from 'antd-v5';
import { updateRepaymentAmountRequest } from '../../../state/request/payEntryData';

const FormItem = Form.Item;

const isIntegerAmount = (value) => {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  return Number.isInteger(Number(value));
};

class EditRepaymentAmount extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
    this.formRef = null;
  }

  handleSubmit = async (values) => {
    const { data, onClose, onRefresh } = this.props;
    this.setState({ loading: true });
    const { code } = await updateRepaymentAmountRequest({
      id: data.id,
      totalRepaymentAmount:
        values.totalRepaymentAmount === undefined || values.totalRepaymentAmount === null
          ? 0
          : Math.trunc(Number(values.totalRepaymentAmount)),
    });
    this.setState({ loading: false });
    if (code === 200) {
      message.success('修改成功');
      onClose();
      onRefresh();
    }
  };

  render() {
    const { visible, onClose, data = {} } = this.props;
    const { loading } = this.state;

    return (
      <Modal
        title='修改回款金额'
        open={visible}
        onOk={() => this.formRef?.submit()}
        onCancel={onClose}
        okText='确定'
        cancelText='取消'
        confirmLoading={loading}
        destroyOnClose
        maskClosable={false}
      >
        <Form
          layout='vertical'
          ref={(r) => {
            this.formRef = r;
          }}
          initialValues={{
            totalRepaymentAmount: data.totalRepaymentAmount ?? 0,
          }}
          onFinish={this.handleSubmit}
        >
          <FormItem
            label='回款金额'
            name='totalRepaymentAmount'
            rules={[
              {
                validator: (_, value) => {
                  if (value === undefined || value === null || value === '') {
                    return Promise.resolve();
                  }
                  if (Number(value) < 0) {
                    return Promise.reject(new Error('回款金额不能小于 0'));
                  }
                  if (!isIntegerAmount(value)) {
                    return Promise.reject(new Error('回款金额不允许为小数'));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber
              placeholder='请输入回款金额'
              style={{ width: '100%' }}
              min={0}
              precision={0}
              step={1}
              controls={false}
            />
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default EditRepaymentAmount;
